var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgBanknote(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M7.241 10C6.561 10 6 10.57 6 11.263v10.105c0 .693.561 1.264 1.241 1.264h18.207c.68 0 1.242-.571 1.242-1.264V11.263c0-.692-.561-1.263-1.242-1.263H7.241zm0 .842h18.207c.237 0 .414.18.414.421v10.105a.407.407 0 01-.414.421H7.241a.407.407 0 01-.413-.42V11.262c0-.24.177-.42.413-.42zm9.104.842c-2.51 0-4.552 2.079-4.552 4.632 0 2.553 2.043 4.631 4.552 4.631 2.51 0 4.552-2.078 4.552-4.631 0-2.553-2.043-4.632-4.552-4.632zm0 .842c2.06 0 3.724 1.693 3.724 3.79s-1.663 3.79-3.724 3.79c-2.06 0-3.724-1.693-3.724-3.79s1.663-3.79 3.724-3.79zm-5.32 5.358c.277 0 .416.221.411.436.004.192-.105.387-.324.428l-.088.008H7.712c-.277 0-.417-.22-.412-.435-.005-.216.134-.437.412-.437h3.312zm14 0c.277 0 .416.221.411.436.004.192-.105.387-.324.428l-.088.008h-3.312c-.277 0-.417-.22-.412-.435-.005-.216.134-.437.412-.437h3.312zm-14-2c.277 0 .416.221.411.436.004.192-.105.387-.324.428l-.088.008H7.712c-.277 0-.417-.22-.412-.435-.005-.216.134-.437.412-.437h3.312zm14 0c.277 0 .416.221.411.436.004.192-.105.387-.324.428l-.088.008h-3.312c-.277 0-.417-.22-.412-.435-.005-.216.134-.437.412-.437h3.312zm-14-2c.277 0 .416.221.411.436.004.192-.105.387-.324.428l-.088.008H7.712c-.277 0-.417-.22-.412-.435-.005-.216.134-.437.412-.437h3.312zm14 0c.277 0 .416.221.411.436.004.192-.105.387-.324.428l-.088.008h-3.312c-.277 0-.417-.22-.412-.435-.005-.216.134-.437.412-.437h3.312z"
  }));
}

export default SvgBanknote;